import React, { FC } from 'react';
import { NotFoundPage as NotFoundPagePk } from 'omni-package-react-core';
import { StyledDiv } from '~/pages/NotFoundPage/NotFoundPage.styles';

export interface NotFoundPageProps { }

const NotFoundPage: FC<NotFoundPageProps> = () => (
  <StyledDiv>
    <NotFoundPagePk redirectUrl="/log-off" />
  </StyledDiv>
);

export default NotFoundPage;
